import styled from 'styled-components';

export const Content = styled.div`
  padding: 10px 12px;
  min-height: 50px;
  box-sizing: border-box;
  flex-grow: 0;

  font-size: 13px;
  white-space: nowrap;
  line-height: 1.2;
  background-color: #161e23;
  border: 1px solid #3d4952;
  border-radius: 10px;
  color: #e6eaec;
  cursor: grab;
  &:active {
    cursor: grabbing;
  }
  /* summary cards ("Постоянные" / "Разовые") get a subtly lighter surface */
  &.common {
    background-color: #1a2429;
    border-color: #3d4952;
  }
`;

export const Name = styled.div`
  margin: 0 0 8px;
  color: #e6eaec;
  font-weight: 600;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Zones = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
